'use client'

import { useFeatureIsOn } from 'growthbook'
import { FEATURE_GROW_3266_HOMEPAGE_SEEDANCE_HOVER_VIEW } from '@web/utils/features'
import { SeedanceShowcaseBlock } from './seedance-showcase-block'

interface SeedanceShowcaseBlockExperimentProps {
  badgeLabel: string
  title: string
  subtitle: string
  ctaLabel: string
  hoverViewLabel: string
  className?: string
}

/**
 * GROW-3266 wrapper. The flag lives here rather than in `SeedanceShowcaseBlock` because the
 * block is also rendered by the (web) 404 page and /internal/snapshot, which are outside the
 * experiment's surface area — and, unlike the homepage, are not guaranteed a GrowthBookProvider.
 *
 * A client hook is enough here (no `StaticVariantsRenderer`): the scrim is hover-only, so there
 * is no first-paint content to flash or shift while the flag resolves.
 */
export function SeedanceShowcaseBlockExperiment({
  hoverViewLabel,
  ...props
}: SeedanceShowcaseBlockExperimentProps) {
  const isHoverViewOn = useFeatureIsOn(FEATURE_GROW_3266_HOMEPAGE_SEEDANCE_HOVER_VIEW)

  return (
    <SeedanceShowcaseBlock {...props} hoverViewLabel={isHoverViewOn ? hoverViewLabel : undefined} />
  )
}
